import { render } from "./ErrorPage.vue?vue&type=template&id=4a464ec2&ts=true"
import script from "./ErrorPage.vue?vue&type=script&lang=ts"
export * from "./ErrorPage.vue?vue&type=script&lang=ts"

import "./ErrorPage.vue?vue&type=style&index=0&id=4a464ec2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__